import { useEffect, useState } from "react";
import {
  collection,
  query as firestoreQuery,
  where,
  orderBy,
  onSnapshot,
} from "firebase/firestore";
import { projectFirestore } from "./firebase/config";

export const useCollection = (
  collectionName,
  queryParams = [],
  orderByParams = []
) => {
  const [documents, setDocuments] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let ref = collection(projectFirestore, collectionName);
    let q = ref;

    // Apply filters (where conditions)
    if (queryParams.length) {
      q = firestoreQuery(q, ...queryParams.map((q) => where(...q)));
    }

    // Apply ordering if specified
    if (orderByParams.length) {
      q = firestoreQuery(q, orderBy(...orderByParams));
    }

    // Fetch documents with real-time updates
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const results = snapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));
        setDocuments(results);
        setError(null);
      },
      (error) => {
        console.error("Error fetching data:", error);
        setError("Could not fetch the data");
      }
    );

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, [
    collectionName,
    JSON.stringify(queryParams),
    JSON.stringify(orderByParams),
  ]);

  return { documents, error };
};
